import { useMemo } from 'react';

import { ServiceType } from '@rover/constants/src/translations/service.constants';

import useLocalizedBrandCountryShim from './useLocalizedBrandCountryShim';

export type ServiceInfo = { url: string; title: string };
export type BrandCountryServices = Partial<Record<ServiceType, ServiceInfo>>;

const useLocalizedBrandCountryServicesByServiceType = (): BrandCountryServices | null => {
  const { localizedBrandCountry } = useLocalizedBrandCountryShim();

  return useMemo(() => {
    if (!localizedBrandCountry?.services) return null;

    const services = {} as BrandCountryServices;
    for (const service of localizedBrandCountry.services) {
      services[service.serviceType as ServiceType] = {
        url: new URL(service.url).pathname,
        title: service.title,
      };
    }
    return services;
  }, [localizedBrandCountry?.services]);
};

export default useLocalizedBrandCountryServicesByServiceType;
